// extracted by mini-css-extract-plugin
export default {"wallet":"WalletSection_wallet__vzlFK"};